var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M8.976 0v14l-5.549-3.343H0V3.343h3.427L8.976 0zm6.188 4.043l.707.707-2.206 2.207 2.292 2.293-.707.707-2.293-2.293-2.293 2.293-.707-.707 2.293-2.293-2.207-2.207.707-.707 2.207 2.206 2.207-2.206z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 5)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#40423F",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#40423F",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4-5h24v24H-4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundMute);
export default __webpack_public_path__ + "static/media/sound-mute.52450bd9eed1cacb36ae1318b46287d0.svg";
export { ForwardRef as ReactComponent };